module.exports = __webpack_public_path__ + "static/media/t-roc.c91796a3.png";